
<template>
  <div>
    <confirm-dialog
      v-if="showDropPlayerDialog"
      :visible="showDropPlayerDialog"
      :title="$t('common.drop-player')"
      :entity="player"
      :text="confirmDialogText"
      confirmButtonClasses="error"
      :closeAction="closeConfirmDialog"
      :confirmAction="confirmedDialog"
    ></confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '../ConfirmDialog.vue';

export default {
  name: "DropPlayerDialog",
  components: {
    ConfirmDialog,
  },
  props: {
    player: {
      type: Object,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
    confirmAction: {
      type: Function,
      required: true
    },
  },
  data: function () {
    return {
    };
  },
  mounted: function () {},
  computed: {
    showDropPlayerDialog: function () {
      return this.player != null
    },
    confirmDialogText: function () {
      return this.$t('common.drop-player-question', {name: this.player.name})
    }
  },
  methods: {
    closeConfirmDialog() {
      this.closeAction()
    },
    confirmedDialog(entity) {
      this.confirmAction(entity)
    }
  },
};
</script>
<style scoped>
</style>
